import { useState } from 'react';
import { postRequest } from '../common/HTTPService';
import WOConnectIcon from './../assets/images/OrderConnect 1.svg';
import EmailFooter from './EmailFooter';
import EmailTable from './EmailTable';
import MakeGoodRecommendation from './MakeGoodRecommendation';
import StatusMessage from './StatusMessage';
import ShimmerTable from './ShimmerTable';
import { MakeGoodSuggestionDetails, PreEmptedSpotDetails } from './types';
import { useMakeFoodRecommendation } from '../context/MakeGoodContext';

const TitleSection = ({
  preEmptedSpotDetails,
}: {
  preEmptedSpotDetails: PreEmptedSpotDetails;
}) => {
  return (
    <>
      <span className="font-semibold text-2xl text-navy-black font-sans">
        Makegood Recommendations
      </span>
      <span className="font-semibold text-[14px] text-navy-black font-sans">
        {`The spot ${
          preEmptedSpotDetails
            ? preEmptedSpotDetails?.order_line_spot_number
            : ''
        } on ${
          preEmptedSpotDetails?.alt_order_number
        } was preempted in WO Traffic`}
      </span>
    </>
  );
};

const EmailContent = ({
  isMakeGoodSuggestionFetching,
}: {
  isMakeGoodSuggestionFetching: boolean;
}) => {
  const { setOfferCreated, currentPreEmptedSpot, preEmptedSpotDetails } =
    useMakeFoodRecommendation();
  const [isCreatingOffer, setIsCreatingOffer] = useState(false);

  const preemptedSpotData = preEmptedSpotDetails
    ? [preEmptedSpotDetails['pre-empted-spot-details']]
    : [];
  const makeGoodSuggestions = preEmptedSpotDetails
    ? preEmptedSpotDetails.makeGoodSuggestions
    : [];
  const createOffer = async (record: MakeGoodSuggestionDetails) => {
    setIsCreatingOffer(true);
    try {
      let result = await postRequest(`/api/v1/create-offer`, {
        spotId: preemptedSpotData[0]?.spot_id,
        inventoryId: record.format_event_detail_id,
        preemptedSpotsTableId: record.preempted_spots_table_id,
      });

      let response = JSON.parse(JSON.stringify(result));
      setOfferCreated(true);
      setIsCreatingOffer(false);
      window.open(decodeURIComponent(response?.OfferURL), '_blank');
    } catch (error) {
      setIsCreatingOffer(false);
      setOfferCreated(false);
    }
  };
  return (
    <div className="relative p-6">
      {isCreatingOffer && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/30 backdrop-blur-[1px]">
          <div className="w-8 h-8 border-4 border-wo-blue border-t-transparent border-solid rounded-full animate-spin"></div>
        </div>
      )}
      <div className="flex flex-col border-1 border-light-grey p-6 rounded-[10px] gap-4 w-full">
        <img
          src={WOConnectIcon}
          alt="WO Connect"
          className="w-[160px] h-[14.02px] "
        />
        <TitleSection
          preEmptedSpotDetails={
            preEmptedSpotDetails?.[
              'pre-empted-spot-details'
            ] as PreEmptedSpotDetails
          }
        />

        {isMakeGoodSuggestionFetching ? (
          <ShimmerTable arraySize={1} />
        ) : (
          <EmailTable data={preemptedSpotData} isPreEmptedSpotDetails={true} />
        )}

        {isMakeGoodSuggestionFetching ? (
          <MakeGoodRecommendation data={makeGoodSuggestions} isLoading={true} />
        ) : makeGoodSuggestions.length > 0 ? (
          <MakeGoodRecommendation
            data={makeGoodSuggestions}
            preEmptedSpotDetails={
              preEmptedSpotDetails?.['pre-empted-spot-details']
            }
            isLoading={false}
            createOffer={createOffer}
          />
        ) : ['new', 'in_progress', 'failed'].includes(
            preemptedSpotData[0]?.status
          ) ? (
          <StatusMessage statusMessage={preemptedSpotData[0]?.status_message} />
        ) : (
          <MakeGoodRecommendation
            data={makeGoodSuggestions}
            preEmptedSpotDetails={
              preEmptedSpotDetails?.['pre-empted-spot-details']
            }
            isLoading={false}
            createOffer={createOffer}
          />
        )}

        <EmailFooter />
      </div>
    </div>
  );
};

export default EmailContent;
